<template>
  <v-card
    class="mx-auto"
    width="800"
  >
    <v-card-title class="title font-weight-regular justify-space-between">
      <span><v-icon color="primary">touch_app</v-icon>{{ currentTitle }}</span>
      <v-avatar
        color="primary lighten-2"
        class="subheading white--text"
        size="24"
        v-text="step"
      ></v-avatar>
    </v-card-title>

    <v-window v-model="step">

      <v-window-item :value="1">
        <v-card-title primary-title>
            <v-container>
                <v-layout align-center justify-center row wrap fill-height>
                  <v-flex xs12>
                    <v-icon color="primary">dashboard</v-icon>
                    {{ inicio }}
                  </v-flex>
                  <v-flex xs12>
                    <h3>Métricas de los agremiados y sus actuaciones</h3>
                    <p>Indicadores de primer nivel de todas las actuaciones realizadas en la plataforma electrónica.</p>
                  </v-flex>
                </v-layout>
            </v-container>
        </v-card-title>
      </v-window-item>

      <v-window-item :value="2">
        <v-card-title primary-title>
              <v-container>
                <v-layout align-center justify-center row wrap fill-height>
                  <v-flex xs12>
                    <v-icon color="primary">traffic</v-icon>
                      {{ sisadmin }}
                  </v-flex>
                  <v-flex xs12 md4>
                    <h3>Auditoría</h3>
                    <p>Traza de movimientos.</p>
                  </v-flex>
                  <v-flex xs12 md4>
                    <h3>Roles</h3>
                    <p>Gestión de Roles.</p>
                  </v-flex>
                  <v-flex xs12 md4>
                    <h3>Permisos</h3>
                    <p>Gestión de Permisos.</p>
                  </v-flex>
                  <v-flex xs12>
                    <p>Control de acceso y monitoreo de actividades en la Plataforma Tecnológica de los diversos usuarios, dispositivos de conexión, Sistemas Operativos, IP Address y métodos del sistema invocados.</p>
                  </v-flex>
                </v-layout>
              </v-container>
        </v-card-title>
      </v-window-item>

      <v-window-item :value="3">
        <v-card-title primary-title>
            <v-container>
                <v-layout align-center justify-center row wrap fill-height>
                  <v-flex xs12>
                    <v-icon color="primary">settings</v-icon>
                    {{ administracion }}
                  </v-flex>
                  <v-flex xs12>
                    <h3>Acciones:</h3>
                    <p>Ninguna, pendiente revisión.</p>
                  </v-flex>
                </v-layout>
              </v-container>
        </v-card-title>
      </v-window-item>

      <v-window-item :value="4">
        <v-card-title primary-title>
          <v-container>
                <v-layout align-center justify-center row wrap fill-height>
                  <v-flex xs12>
                    <v-icon color="primary">perm_data_setting</v-icon>
                      {{ atencion_agremiado }}
                  </v-flex>
                  <v-flex xs12>
                    <h3>Mantenimiento</h3>
                    <p>Módulo de actualización de datos relacionados con el Contador Público Colegiado.</p>
                  </v-flex>
                </v-layout>
              </v-container>
        </v-card-title>
      </v-window-item>



      <v-window-item :value="5">
        <v-card-title primary-title>

          <v-container>
                <v-layout align-center justify-center row wrap fill-height>
                  <v-flex xs12>
                    <v-icon color="primary">monetization_on</v-icon>
                      {{ cobranza }}
                  </v-flex>
                  <v-flex xs12>
                    <h3>Mantenimiento</h3>
                    <p>Gestión de precios de los conceptos Gestión Gremial, Servicio Electrónico y Registro de la Actuación Profesional.</p>
                    <p>Gestión de los Tipos de Documentos objeto de la Protección Profesional.</p>
                    <p>Monitoreo del Papel de Seguridad.</p>
                  </v-flex>
                </v-layout>
              </v-container>
         </v-card-title>
      </v-window-item>


      <v-window-item :value="6">
        <v-card-title primary-title>

              <v-container>
                <v-layout align-center justify-center row wrap fill-height>
                  <v-flex xs12>
                    <v-icon color="primary">assistant</v-icon>
                      {{ sala_tecnica }}
                  </v-flex>
                  <v-flex xs12>
                    <h3>Aprobación o Devolución</h3>
                    <p>Revisión de la Actuación Profesional para la Aprobación o Devolución al Contador Público Colegiado.</p>
                  </v-flex>
                </v-layout>
              </v-container>
        </v-card-title>
      </v-window-item>


      <v-window-item :value="7">
        <v-card-title primary-title>
            <div>
              <v-icon color="primary">mdi-folder-download</v-icon>
              {{ respaldo }}
              </div>
        </v-card-title>
      </v-window-item>

      <v-window-item :value="8">
        <v-card-title primary-title>
            <div>
              <v-icon color="primary">help</v-icon>
              {{ ayuda }}
              </div>
        </v-card-title>
      </v-window-item>

    </v-window>

    <v-divider></v-divider>

    <v-card-actions>
      <v-btn
        :disabled="step === 1"
        flat
        @click="step--"
      >
        Atras
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        :disabled="step === 8"
        color="primary"
        depressed
        @click="step++"
      >
        Siguiente
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    data: () => ({
      step: 1,
        inicio: 'Resumen del RAPE en el CCPDC.',
        sisadmin: 'Permisos, Roles y Auditoría del Sistema.',
        administracion: 'Gestión Administrativa.',
        atencion_agremiado: 'Administración de los Contadores Públicos Colegiados en el CCPDC.',
        cobranza: 'Administración de precios y conciliación bancaria.',
        sala_tecnica: 'Servicio de Protección de la Actuación Profesional Electrónico RAPE.',
        respaldo: 'Consulta y Descarga de los transacciones del RAPE por fecha.',
        ayuda: 'Funcionalidades del sistema.'

    }),

    computed: {
      currentTitle () {
        switch (this.step) {
          case 1:  return 'Inicio'
          case 2:  return 'SisAdmin'
          case 3:  return 'Administración'
          case 4:  return 'Atención Agremiado'
          case 5:  return 'Cobranza'
          case 6:  return 'Sala Técnica'
          case 7:  return 'Respaldo'
          default: return 'Ayuda'
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/helpAdmin.vue